<template>
  <div class="marginLR">
    <div class="grid dashboard">
      <div class="col-12 mb-1 mt-2">
        <AltaImpago
          :operacionUuid="selOperacion"
          :clienteIdLegal="clienteIdLegal"
          :displayModal="displayAltaImpago"
          v-on:close-dialog="cerrarModal"
        />

        <div class="col-12">
          <h2 class="titles">
            {{ $t("expedientes.titulo3") + ": " }} <span class="text-xl">{{this.cartera.nombre}}</span> 
          </h2>
        </div>
      </div>
      <div class="col-12">
        <div class="card">
          <DataTable
            :value="operations.items"
            :loading="loading"
            :lazy="true"
            :paginator="true"
            :rows="tamPagina"
            :totalRecords="operations.totalElements"
            :filters.sync="filters"
            :expandedRows.sync="expandedRows"
            class="p-datatable-sm"
            :autoLayout="true"
            dataKey="token"
            @sort="customSort($event)"
            @page="onPage($event)"
            @row-click="clicked"
          >
            <template #empty>
              {{ $t("expedientes.datatable.noExpedientes") }}
            </template>

            <template #footer>
              <div class="grid">
                <div class="col-4 col-offset-8" style="text-align: right">
                  <Button
                    @click="
                      exportarExcelOperacionByFilters(backendFilters, sort)
                    "
                    :icon="
                      !exportandoDatos
                        ? 'pi pi-external-link'
                        : 'pi pi-spin pi-spinner'
                    "
                    :label="$t('common.buttons.export')"
                    class="p-button-text p-button-outlined"
                    :disabled="
                      exportandoDatos ||
                      !operations ||
                      operations.totalElements == 0
                    "
                  />
                </div>
              </div>
            </template>

            <Column :expander="true" headerStyle="width: 3em">
              <template #header>
                <button
                  class="p-row-toggler p-link center"
                  @click="expandOrCollapse()"
                >
                  <span :class="expandClass"></span>
                </button>
              </template>
            </Column>

            <Column
              field="token"
              :header="$t('expedientes.header.nReferenciaLargeExp')"
              :sortable="false"
              headerStyle="width: 11em"
            >
              <template #body="slotProps">
                {{ slotProps.data.token }}
              </template>
            </Column>
            <Column
              field="referenciaCliente"
              :header="$t('expedientes.header.referenciaCliente')"
              :sortable="false"
              headerStyle="width: 11em"
            >
              <template #body="slotProps">
                {{ slotProps.data.referenciaCliente }}
              </template>
            </Column>
            <Column
              field="fechaAlta"
              :header="$t('expedientes.header.fecha')"
              :sortable="true"
              headerStyle="width: 7em"
            >
              <template #body="slotProps">
                {{ getFormattedDateShort(slotProps.data.fechaAlta) }}
              </template>
            </Column>
            <Column
              field="origenDeuda"
              :header="$t('expedientes.header.origenDeuda')"
            >
              <template #body="slotProps">
                {{ slotProps.data.literalOrigenDeudaDetalle.valor }}
              </template>
            </Column>
            <Column
              field="reclamado"
              :header="$t('expedientes.header.reclamado')"
              :sortable="false"
              :headerStyle="headerStyle"
            >
              <template #body="slotProps">
                {{
                  getFullName(
                    slotProps.data.deudorNombre,
                    slotProps.data.deudorApellidos,
                    slotProps.data.deudorRazonSocial
                  )
                }}
              </template>
            </Column>
            <Column
              field="acreedor"
              :header="$t('expedientes.header.acreedor')"
              :sortable="false"
              :headerStyle="headerStyle"
            >
              <template #body="slotProps">
                {{
                  getFullName(
                    slotProps.data.acreedorNombre,
                    slotProps.data.acreedorApellidos,
                    slotProps.data.acreedorRazonSocial
                  )
                }}
              </template>
            </Column>
            <Column
              field="cartera"
              :header="$t('expedientes.header.cartera')"
              :sortable="false"
              :headerStyle="headerStyle"
            >
              <template #body="slotProps">
                {{
                  slotProps.data.cartera ? slotProps.data.cartera.nombre : ""
                }}
              </template>
            </Column>
            <Column
              field="ficha"
              :header="$t('expedientes.header.acciones')"
              :sortable="false"
              :headerClass="expandWidth"
            >
              <template #body="slotProps">
                <!--<Button class="ficha centerButton" :label="$t('common.buttons.ver')" icon="pi pi-chevron-right" iconPos="right" @click="onSeeExpedientClick(slotProps.data.uuid)"/>-->
                <div class="flex justify-content-between">
                  <Button
                    type="button"
                    v-tooltip.bottom="$t('operacion.botonDetalleExpediente')"
                    icon="pi pi-search"
                    class="p-button-success"
                    @click="onSeeExpedientClick(slotProps.data.uuid)"
                  />
                  <Button
                    type="button"
                    v-tooltip.bottom="$t('operacion.botonCrearImpago')"
                    icon="pi pi-plus"
                    class="p-button-success"
                    @click="newImpago(slotProps.data.uuid)"
                  />
                </div>
              </template>
            </Column>
            <template #expansion="slotProps">
              <div>
                <DataTable
                  :value="slotProps.data.listaImpagos"
                  :header="$t('expedientes.header.reclamacion')"
                  class="
                    p-datatable-responsive
                    tableExpansion
                    expedientesDatatable
                  "
                >
                  <Column
                    field="token"
                    :header="$t('expedientes.header.impagos.nReferencia')"
                    :sortable="false"
                    :headerStyle="headerStyle"
                  >
                    <template #body="slotProps">
                      <span class="p-column-title">{{
                        $t("expedientes.label.nReferencia")
                      }}</span>
                      <template v-if="slotProps.data.referenciaCliente">
                        {{ slotProps.data.referenciaCliente }}
                      </template>
                      <template v-else>
                        {{ slotProps.data.reclamacionToken }}
                      </template>
                    </template>
                  </Column>
                  <Column
                    :header="$t('expedientes.header.impagos.token')"
                    :headerStyle="headerStyle"
                  >
                    <template #body="slotProps">
                      {{ slotProps.data.reclamacion.token }}
                    </template>
                  </Column>
                  <Column
                    field="fechaAlta"
                    :header="$t('expedientes.header.impagos.fechaImpago')"
                    :headerStyle="headerStyle"
                  >
                    <template #body="slotProps">
                      <span class="p-column-title">{{
                        $t("expedientes.header.impagos.fechaImpago")
                      }}</span>
                      {{ getFormattedDateShort(slotProps.data.fechaAlta) }}
                    </template>
                  </Column>
                  <Column
                    field="fechaAltaReclamacion"
                    :header="$t('expedientes.header.impagos.fechaReclamacion')"
                    :headerStyle="headerStyle"
                  >
                    <template #body="slotProps">
                      <span class="p-column-title">{{
                        $t("expedientes.header.impagos.fechaReclamacion")
                      }}</span>
                      {{
                        getFormattedDateShort(
                          slotProps.data.reclamacion.fechaAlta
                        )
                      }}
                    </template>
                  </Column>

                  <Column
                    field="totalPendiente"
                    :header="$t('expedientes.label.pendiente')"
                    :sortable="false"
                    :headerStyle="headerStyle"
                  >
                    <template #body="slotProps">
                      <span class="p-column-title">{{
                        $t("expedientes.label.pendiente")
                      }}</span>
                      {{
                        slotProps.data.importePendiente
                          | toCurrency("es-ES", slotProps.data.divisa)
                      }}
                    </template>
                  </Column>
                  <Column
                    field="estado"
                    :header="$t('impago.recuperado')"
                    :sortable="false"
                    :headerStyle="headerStyle"
                  >
                    <template #body="slotProps">
                      <span class="p-column-title">{{
                        $t("impago.recuperado")
                      }}</span>
                      {{
                        slotProps.data.recuperado
                          ? $t("common.yes")
                          : $t("common.no")
                      }}
                    </template>
                  </Column>
                  <Column
                    :header="$t('expedientes.header.impagos.estado')"
                    :headerStyle="headerStyle"
                  >
                    <template #body="slotProps">
                      {{ slotProps.data.reclamacion.estado }}
                    </template>
                  </Column>
                  <Column
                    field="ficha"
                    :header="$t('datos.header.acciones')"
                    :sortable="false"
                    :headerStyle="headerStyle"
                    bodyStyle="text-align:center"
                  >
                    <template #body="slotProps">
                      <BotoneraAccionesImpago
                        :impagoUuid="slotProps.data.uuid"
                        :reclamacion="slotProps.data.reclamacion"
                        :importePendiente="slotProps.data.importePendiente"
                        @on-action-processed="onActionProcessed"
                      />
                    </template>
                  </Column>
                </DataTable>
              </div>
            </template>
          </DataTable>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { QUERY_GET_OPERATIONS_WITH_IMPAGOS } from "@/graphQLQueries/OperacionQueries";

import DatesMixin from "@/utils/dates";
import StringsMixin from "@/utils/strings";
import CurrencyMixin from "@/utils/currency";
import RoutesMixin from "@/utils/routes";

import AltaImpago from "@/components/portal-gran-cliente/editar/AltaImpago.vue";
import BotoneraAccionesImpago from "@/components/portal-gran-cliente/Expedientes/BotoneraAccionesImpago.vue";
import ExportExcelMixin from "@/utils/exportExcel";
import { mapGetters } from "vuex";

export default {
  name: "ListadoExpedientesCartera",
  components: {
    AltaImpago: AltaImpago,
    BotoneraAccionesImpago: BotoneraAccionesImpago,
  },
  props: {
    cartera: { type: Object }
  },
  mixins: [
    DatesMixin,
    StringsMixin,
    CurrencyMixin,
    RoutesMixin,
    ExportExcelMixin,
  ],
  data() {
    return {
      clienteIdLegal: null,
      selOperacion: null,
      displayAltaImpago: false,
      sort: ["-fechaAlta"],
      numPagina: 0,
      tamPagina: 10,
      loading: true,
      loadingParam:true,
      expandedRows: [],
      detallesReclamacion: {},
      filters: {},
      filterCartera: [],
      drafts: [],
      operations: { items: [], totalElements: 0 },
      headerStyle: "text-align: center",
      expandWidth: "expandWidth",
      expandClass:
        "p-column-title p-row-toggler-icon pi pi-fw p-clickable pi-chevron-right",
    };
  },
  computed: {
    ...mapGetters(["getCarteras", "getCarterasOperativas"]),
    backendFilters() {
      if (this.loadingParam){
        const referenciaCliente = this.$route.params.refCli;
        if (referenciaCliente !== undefined){
          this.filters['referenciaCliente'] = referenciaCliente;
        }
      }
      let filters2 = [];
      if (this.filters) {
        for (let [key, value] of Object.entries(this.filters)) {
          if (value != null && value != undefined && `${value}`) {
            filters2.push(`${key}~ilike=${value}`);
          }
        }
      }
      let carteraIn = "cartera.nombre~in=" + this.cartera.nombre;
      filters2.push(carteraIn);
      return filters2;
    },
  },
  apollo: {
    operations: {
      query: QUERY_GET_OPERATIONS_WITH_IMPAGOS,
      variables() {
        return {
          criteria: {
            filter: this.backendFilters,
            page: this.numPagina,
            size: this.tamPagina,
            sort: this.sort,
          },
          idioma: this.$i18n.locale,
        };
      },
      fetchPolicy: "no-cache",
      update(data) {
        const operations = data.listaOperaciones;
        this.loading = false;
        return {
          items: operations.results,
          totalElements: operations.totalElements,
        };
      },
      skip() {
        if (
          this.$store.state.clienteUuid != null &&
          this.$store.state.clienteUuid != undefined
        ) {
          return false;
        } else {
          this.loading = false;
          return true;
        }
      },
    },
  },
  created() {
    this.loadingParam=false;
    console.log(this.cartera)
  },
  methods: {
    clearFields() {
      this.filters = {};
    },
    search() {
      this.loading = true;

      this.$apollo.queries.operations.refetch();
    },
    onPage(event) {
      this.numPagina = event.page;
    },
    customSort(event) {
      let sortField = event.sortField;
      let sortOrder = event.sortOrder == -1 ? "-" : "";
      let sortToApply = sortOrder + sortField;
      let sorts = [sortToApply];
      this.sort = sorts;
      this.search();
    },
    expandOrCollapse() {
      this.expandClass.includes("pi-chevron-right") == true
        ? this.expandAll()
        : this.collapseAll();
    },
    expandAll() {
      this.expandClass =
        "p-column-title p-row-toggler-icon pi pi-fw p-clickable pi-chevron-down";
      this.expandedRows = this.operations.items.filter((o) => o.token);
    },
    collapseAll() {
      this.expandClass =
        "p-column-title p-row-toggler-icon pi pi-fw p-clickable pi-chevron-right";
      this.expandedRows = [];
    },
    onSeeClaimClick(token) {
      this.goToClaimView(token);
    },
    onSeeExpedientClick(uuid) {
      this.goToExpedientView(uuid);
    },
    clicked(value) {
      if (this.expandedRows.includes(value.data)) {
        this.expandClass =
          "p-column-title p-row-toggler-icon pi pi-fw p-clickable pi-chevron-right";
        const index = this.expandedRows.indexOf(value.data);
        if (index > -1) {
          this.expandedRows.splice(index, 1);
        }
      } else {
        this.expandClass =
          "p-column-title p-row-toggler-icon pi pi-fw p-clickable pi-chevron-down";
        this.expandedRows.push(value.data);
      }
    },
    newImpago(uuid) {
      this.displayAltaImpago = true;
      this.selOperacion = uuid;
    },
    cerrarModal() {
      this.displayAltaImpago = false;
      this.onActionProcessed();
    },
    onActionProcessed() {
      this.search();
    },
  },
};
</script>
<style lang="scss">
.p-multiselect-label-empty {
  visibility: visible;
}
.expandWidth {
  width: 6.5em !important;
}
</style>